import AppDropDown from "@toothfairy/shared-ui/AppDropDown";
import AppTheme from "@toothfairy/shared-ui/AppTheme";
import AppToast from "@toothfairy/shared-ui/AppToast";
import AppUser from "@toothfairy/shared-ui/AppUser";
import React from "react";
import { useTranslation } from "react-i18next";
import { AVAILABLE_LANGUAGES, changeLanguage } from "../../../i18n.config";
import usersHelper from "../../API/Users/usersHelper";

const LanguageSelector = ({ wrapperStyle = {}, dropDownStyle = {} }) => {
  const { currentTheme } = AppTheme.useTheme();
  const { t, i18n } = useTranslation();
  const AppToasty = AppToast.useToast();
  const { user, updateUser } = AppUser.useUser();

  const currentLanguage = i18n.language || "en";

  const handleLanguageChange = async (languageCode) => {
    try {
      await changeLanguage(languageCode);
      usersHelper.updateUser(user?.id, [
        { property: "language", value: languageCode },
      ]);
      updateUser({ ...user, language: languageCode });
      AppToasty.show(t("language.changed"), { type: "success" });
    } catch (error) {
      AppToasty.show(t("language.changeFailed"), { type: "danger" });
    }
  };

  const languageOptions = AVAILABLE_LANGUAGES.map((lang) => ({
    id: lang.code,
    internalTitle: lang.nativeName,
    title: lang.name,
  }));

  return (
    <AppDropDown
      showTextInputLabel
      label={t("language.title")}
      dropDownStyle={{
        borderColor: currentTheme?.theme?.border_color,
        maxWidth: 250,
        ...dropDownStyle,
      }}
      wrapperContainer={{
        paddingBottom: 15,
        ...wrapperStyle,
      }}
      inputLabelStyle={{
        marginLeft: 0,
      }}
      isElevated={false}
      dropdownIconColor="transparent"
      items={languageOptions}
      propertyLabel="internalTitle"
      propertyValue="id"
      selectedValue={currentLanguage}
      onValueChange={(itemValue) => {
        handleLanguageChange(itemValue);
      }}
    />
  );
};

export default LanguageSelector;
